export default "<div class=\"progress-bar\" *ngIf=\"isLoading\" >\n    <mat-progress-bar mode=\"indeterminate\"></mat-progress-bar>\n</div>\n"